import { Box, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { ExternalLinkSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { BiCtaNames } from '../../bi/types';
import { ACCESSIBILITY_TIPS_ARTICLE_ID } from '../../consts';
import { useA11yWizardAdapter } from '../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../hooks/use-bi-logger';
import { useSessionInfoContext } from '../../hooks/use-session-info-context';
import { getArticleLink } from '../../utils/get-article-link';
export const WizardFooterManualTasks = () => {
  const {
    t
  } = useTranslation();
  const {
    locale
  } = useSessionInfoContext();
  const biLogger = useBiLogger();
  const {
    capabilities
  } = useA11yWizardAdapter();
  const compactPanelChrome = capabilities.compactPanelChrome;
  const handleClick = () => {
    biLogger.ctaClick({
      ctaName: BiCtaNames.GetMoreA11yTips
    });
    window.open(getArticleLink(ACCESSIBILITY_TIPS_ARTICLE_ID, locale ?? ''), '_blank');
  };
  const handleKeyDown = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleClick();
    }
  };
  return /*#__PURE__*/React.createElement(Box, {
    align: compactPanelChrome ? undefined : 'center',
    direction: "vertical",
    gap: "SP2",
    padding: compactPanelChrome ? 'SP3 SP4 SP3 SP4' : 'SP2 0 SP2 0',
    width: compactPanelChrome ? '100%' : '252px'
  }, /*#__PURE__*/React.createElement(TextButton, {
    as: "a",
    ellipsis: true,
    size: compactPanelChrome ? 'tiny' : 'small',
    skin: compactPanelChrome ? 'dark' : undefined,
    suffixIcon: /*#__PURE__*/React.createElement(ExternalLinkSmall, {
      "aria-label": t('accessibility-wizard.manual-tasks.footer.open-in-a-new-tab.cta.aria-label')
    }),
    target: "_blank",
    underline: "always",
    onClick: handleClick,
    onKeyDown: handleKeyDown
  }, t('accessibility-wizard.manual-tasks.footer.learn-more.cta')));
};
//# sourceMappingURL=wizard-footer-manual-tasks.js.map